import { __decorate, __metadata } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvProgressBar";
let LvProgressBar = class LvProgressBar extends UIComponent {
    get shouldShowValue() {
        return this.showValue && !this.indeterminate;
    }
    get progressBarCurrentStyle() {
        return {
            width: this.indeterminate ? null : `${this.progress}%`,
        };
    }
    get isActive() {
        return this.progress < 100 || this.indeterminate;
    }
};
__decorate([
    Prop({ type: Number, required: false, default: 0 }),
    __metadata("design:type", Number)
], LvProgressBar.prototype, "progress", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true }),
    __metadata("design:type", Boolean)
], LvProgressBar.prototype, "showValue", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], LvProgressBar.prototype, "indeterminate", void 0);
__decorate([
    Prop({ type: String, required: false, default: null }),
    __metadata("design:type", Object)
], LvProgressBar.prototype, "state", void 0);
__decorate([
    Prop({ type: Number, required: false, default: 5 }),
    __metadata("design:type", Number)
], LvProgressBar.prototype, "height", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true }),
    __metadata("design:type", Boolean)
], LvProgressBar.prototype, "rounded", void 0);
LvProgressBar = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvProgressBar);
export default LvProgressBar;
//# sourceMappingURL=script.js.map